import { 
  Drawer, IconButton, List, ListItemButton, ListItemText, useMediaQuery, ListItemIcon } from '@mui/material';
import React, { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { scrollTo } from 'scroll-js';

const PAGES = [
  { name: "HOME", id: "#" },
  { name: "ABOUT", id: "about" },
  { name: "TESTIMONIALS", id: "testimonial" },
  { name: "HIRE ME", id: "contact" },
  { name: "CONTACTS", id: "contact" },
  { name: "SERVICES", id: "services" },
];

export default function DrawerComp() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleItemClick = (id) => {
    if (isMobile) {
      setOpenDrawer(false);
    }
    const element = document.getElementById(id);
    if (element) {
      const top = element.offsetTop;
      scrollTo(document.scrollingElement, { top, behavior: 'smooth' });
    }
  };

  return (
    <React.Fragment>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <List>
          {PAGES.map((page, index) => (
            <ListItemButton key={index} onClick={() => handleItemClick(page.id)}>
              <ListItemIcon>
                <ListItemText>{page.name}</ListItemText>
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      <IconButton sx={{ color: 'white', marginLeft: 'auto' }} onClick={() => setOpenDrawer(!openDrawer)}>
        <MenuIcon />
      </IconButton>
    </React.Fragment>
  );
}
